import React from 'react';

import config from '../../config';
import {type RouteData} from '../types';
import {
  ACADEMIC_APPLICATION_PATH,
  ONBOARDING_FLOW_PATH,
  QUICKSTART_PATH,
  STARTUP_PROGRAM_PATH,
  TRIAL_END_PATH,
} from './onboardingPaths';

const IS_PRIVATE_ENV = config.ENVIRONMENT_IS_PRIVATE;

/**
 * These are paths that are related to onboarding a user for the very first time.
 */
export const ONBOARDING_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'QuickStart',
    },
    exact: true,
    isPrivateRoute: false,
    path: QUICKSTART_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'OnboardingFlow',
    },
    isPrivateRoute: true,
    path: ONBOARDING_FLOW_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/OnboardingFlow/OnboardingFlow')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'StartupProgram',
    },
    condition: !config.ENVIRONMENT_IS_PRIVATE,
    exact: true,
    isPrivateRoute: true,
    path: STARTUP_PROGRAM_PATH,
    RouteComponent: React.lazy(() => import('../../pages/StartupProgram')),
  },
];

export const TRIAL_END_ROUTE_DATA: RouteData = {
  additionalProps: {
    allowIframes: false,
    routeName: 'TrialEnd',
  },
  condition: !IS_PRIVATE_ENV,
  exact: true,
  isPrivateRoute: true,
  path: TRIAL_END_PATH,
  RouteComponent: React.lazy(
    () => import('../../pages/TrialEndPage/TrialEndPage')
  ),
};

export const ACADEMIC_APPLICATION_ROUTE_DATA: RouteData = {
  additionalProps: {
    allowIframes: false,
    routeName: 'AcademicApplication',
  },
  condition: !IS_PRIVATE_ENV,
  exact: true,
  isPrivateRoute: true,
  path: ACADEMIC_APPLICATION_PATH,
  RouteComponent: React.lazy(
    () => import('../../pages/AcademicApplication/AcademicApplication')
  ),
};
